import { useQuery } from "@apollo/client";
import { SFDC_INTEGRATIONS_QUERY } from "../../../apis/salesforce/queries";
import { SfdcIntegrationsResponse, SfdcIntegrationsVariables } from "../types";
import { HG_FORCE_CLIENT } from "../../../utils/consts";

export interface UseSfdcIntegrationsOptions {
  skip?: boolean;
  pollInterval?: number;
  fetchPolicy?:
    | "cache-first"
    | "cache-and-network"
    | "network-only"
    | "cache-only"
    | "standby";
}

export const useSfdcIntegrations = (
  options: UseSfdcIntegrationsOptions = {}
) => {
  const { skip = false, pollInterval, fetchPolicy = "cache-first" } = options;

  const result = useQuery<SfdcIntegrationsResponse, SfdcIntegrationsVariables>(
    SFDC_INTEGRATIONS_QUERY,
    {
      context: { clientName: HG_FORCE_CLIENT },
      skip,
      pollInterval,
      fetchPolicy,
      errorPolicy: "all",
    }
  );

  return {
    ...result,
    integrations: result.data?.integrations || [],
  };
};
